import { Stack, Text, ButtonLink, Actions } from 'braid-design-system';
import queryString from 'query-string';
import { useSelector } from 'react-redux';

import { getConfigValues } from 'src/config';
import Routes from 'src/config/routes';
import type { StoreProps } from 'src/store';

const NoListings = () => {
  const clientNumber = useSelector(
    ({ account }: StoreProps) => account.clientNumber,
  );
  const hasPaid = useSelector((store: StoreProps) => store.account.paid);

  const createAdLink = queryString.stringifyUrl({
    url: hasPaid
      ? getConfigValues().ADVERTISER_CENTRE_URL + Routes.CREATE_AD_URL
      : Routes.PACKAGES,
    query: hasPaid
      ? {
          ClientId: clientNumber.toString(),
        }
      : undefined,
  });

  return (
    <Stack space="medium">
      <Text>
        Welcome to SEEK Business. Create an ad to showcase your business to
        Australia&apos;s largest buying audience.
      </Text>

      <Actions>
        <ButtonLink href={createAdLink} tone="formAccent">
          Create an ad
        </ButtonLink>
      </Actions>
    </Stack>
  );
};

export default NoListings;
